<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-sacrifice-icon01.svg" alt="*" />あなたの潜在意識
				</span>
			</div><!-- end .type -->
			<div class="cover">
					他人本位{{sacrificeMindResult.percentageLeft}}%、自分本位{{sacrificeMindResult.percentageRight}}%
			</div><!-- end .cover -->	
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自分一人の時間をきちんと確保し、技術や感性を磨く時間を増やしていこう</h2>
			<img src="../assets/result-detail-sacrifice-inright01.svg" alt="*" class="visual" />
			<div class="caption">
				より多くの分野で、より深い内向的な経験を与えることで、あなたはどこまで成長できる
			</div><!-- end .caption -->
			<p>今回の診断で、あなたの潜在意識は自分本位志向が強いことが分かりました。あなたは内向度が{{levelResult.percentage}}%と高いため、この潜在意識と相まって、与えられた状況や環境と自分を結び付けて考えることがとても得意だと言えるでしょう。</p>
			<p>自分本位とは、どんなケースにおいても、「自分なら」「自分の場合は…」と、自分について優先的に考える思考性を示します。どんな他人事でも、自分に置き換え続けることにより、あらゆる物事の理解力が抜群に増すわけです。</p>
			<p>あなたの内向度と潜在式が相乗効果を生み出すのは、「圧倒的な自由」を与えられたときです。選択や思考が重要な状態で、自分のことを多面的に捉えられる環境こそが、あなたにはぴったりなのです。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>自意識の過剰さに打ち勝つことができれば、あなたの自分本位は、幸福度を抜群に引き上げる</h2>
			<img src="../assets/result-detail-sacrifice-inright02.svg" alt="*" class="visual" />
			<div class="caption">
				自意識過剰は悪ではない。正しい扱い方をすれば、あなたの才能を引き上げる最良のスパイスとなる
			</div><!-- end .caption -->
			<p>自分本位の意識が強い場合、内向度に負の影響もしばしば与えることも多くなります。内向度の強いあなたが、自分本位な気持ちや想いを外に出さずにひた隠しにしていると、あなたは周囲から、「何を考えているか分からない」「自分の強い世界観の中で生きている」と認識されてしまうからです。</p>
			<p>良い意味で捉えると、内向度が高く、自分本位意識が強いあなたは、アーティスティックなのです。そうなると、あなたの人生の勝敗は、あなたのアーティスト性を汲み取ってくれる人物との出会いが大きな鍵を握るでしょう。</p>
			<p>自分のことばかりに意識がとらわれ、その意識が内に向かうということは、あなたはとても自意識過剰な一面を持っていると言えます。まったく無知で臨んだり、まったく場違いの場所などに飛び込んだりすることは、得意ではないようです。</p>
			<p>しかし、自意識過剰は大きな味方になってくれます。意識が過剰であるからこそ、アイデアやヒントも過剰に溢れ出すからです。自意識過剰だからこそ他人よりも自分の人生を際立てる最も重要なマインドセットは、「事前にスキルをセットアップしておく」ということです。そして、事前にスキルをセットアップし、それを披露したり、それをカスタマイズしたりする仕事や役割が、あなたらしさを十二分に発揮できる場所だと言えます。</p>
			<p>事前のスキルセットアップが、自意識過剰による不安や緊張を大きく緩和し、むしろ、攻めの姿勢で思考やコミュニケーションを取れるようなあなたを作っていくでしょう。</p>
			<p>自己本位の強さはあなたに備わった武器です。自意識の過剰な部分を上手に扱うことで、我がまま・気ままさ・自己陶酔感は、あなたの才能を引き上げる最良のスパイスとなるのです。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<h2>自分の好きなことに対して、コミットする力が、あなたの人生の価値を変化させる</h2>
			<img src="../assets/result-detail-sacrifice-inright03.svg" alt="*" class="visual" />
			<div class="caption">
				好きなことに正直に向き合うことが、他人を幸福にすることにも繋がる
			</div><!-- end .caption -->
			<p>しかし、「自分勝手」は決して悪いことではありません。自分勝手とは、「自分を思いのままに操ろうとする強い意志」だからです。そして、あなたは内向的です。マイペースを維持し、自分らしさや自分の思考や価値観を自由に振舞える時間をいかに確保できるかが、あなたの成功や幸福に大きく関わっていくでしょう。</p>
			<p>あなたも人間ですから、異性や友人や同僚や世間との関わりの中で満たしたい欲求も出てくるでしょう。あなたが、自分本位に自分の「一芸」を磨くことができれば、あなたは他人から自然に求められるようになります。自分本位な物事にコミットしたことによって、あなは自尊心と余裕を得ることができます。そうなると、自然に外向的なコミュニケーション能力は高まっていきます。余裕とは、心の余力のことで、自分事以外に扱えるメンタルエネルギーのようなものです。</p>
			<p>また、誰かに会ったり、集団で何かをする際も、それは「自分の時間を奪われている」と考え込むのは止めましょう。誰かに会うとき、集団で何かをする際も、自分で課題や目標を持つことで、自己成長の時間にすることができます。すると、あなたは他人に巻き込まれることでしか得られなかった感性や視点が意外にも多くあることに気づいていくでしょう。そうなると、あなたの自己本位は自分も他人も幸せにできる素晴らしいものとなり、あなたの我がままや気ままさは大きな長所になっていくのです。</p>
		</div><!-- end .sentence -->
	</div><!-- end .contents -->			
</template>
		

<script>


export default {
	name: 'ResultDetailSacrificeInRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//sacrificeMind
		sacrificeMindResult:function(){
			return this.$store.getters.sacrificeMindResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
